// RoofShingles recipe — Buildings Set1 §7.4: offset scale/tab rows with per-tab colour jitter
// (asphalt shingle). Uses the new `shingles` primitive. Immutable built-in root.
import {MaterialLayer, MaterialRecipe, ParamSchema} from "../@MaterialTypes.js";

export const ROOF_SHINGLES_RECIPE_ID = "roofShingles";

export const roofShinglesRecipe = new MaterialRecipe({
	id: ROOF_SHINGLES_RECIPE_ID,
	name: "Roof shingles",
	roughness: 0.85,
	specStrength: 0.05,

	params: [
		new ParamSchema({key: "tab_width", label: "Tab width (m)", kind: "scalar", min: 0.05, max: 1, default: 0.2}),
		new ParamSchema({key: "tab_height", label: "Tab height (m)", kind: "scalar", min: 0.02, max: 0.3, default: 0.05}),
		new ParamSchema({key: "stagger", label: "Tab stagger", kind: "scalar", min: 0, max: 1, default: 0.5}),
		new ParamSchema({key: "shingle_ramp", label: "Shingle ramp", kind: "ramp", default: [0, 0.22, 0.21, 0.2, 0.5, 0.34, 0.32, 0.3, 1, 0.5, 0.45, 0.4]}),
		new ParamSchema({key: "shadow_depth", label: "Tab shadow (m)", kind: "scalar", min: 0, max: 0.02, default: 0.004}),
		new ParamSchema({key: "gap_color", label: "Gap colour", kind: "color", default: [0.08, 0.07, 0.06]}),
	],
	layers: [
		new MaterialLayer({
			id: "tabs",
			primitive: "shingles",
			args: {
				tabWidth: {ref: "tab_width"},
				tabHeight: {ref: "tab_height"},
				stagger: {ref: "stagger"},
				shingleRamp: {ref: "shingle_ramp"},
				shadowDepth: {ref: "shadow_depth"},
				gapColor: {ref: "gap_color"},
			},
			blend: "over",
			contributes: "both",
		}),
	],
});
